export const COMPLAINT_BOOK = "https://www.livroreclamacoes.pt/";
export const PERMIT_CREATION_FORM = `${process.env.REACT_APP_IPARQUE_DRIVER_URL}${process.env.REACT_APP_PERMIT_CREATION_FORM_URL}`;
export const DRIVER_APP_APPLE_URL =
  "https://apps.apple.com/pt/app/iparque-mobile/id526743514";
export const DRIVER_APP_ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.acin.iparque";
